export const USER_RECEIVED = 'USER_RECEIVED';

const getUser = () => (
  (dispatch) => {
    dispatch({
      type: USER_RECEIVED,
      user: window.user,
    });
  }
);

export default getUser;
